import React from 'react';
import { LANGUAGES } from '../data/conversations';

export default function Languages() {
  return (
    <section className="section dark section--languages" id="languages">
      <div className="wrap">
        <div className="section__head section__head--center" data-reveal>
          <p className="eyebrow">Multilingual AI</p>
          <h2 className="h2">
            Speaks your customers' language, <em>and says "paneer" correctly.</em>
          </h2>
          <p className="lead">
            Your regulars order the way they talk at home, whether that's Spanish, Mandarin or
            Punjabi. The AI answers in their language and pronounces your dishes the way your
            community does.
          </p>
        </div>
        <div className="langs">
          {LANGUAGES.map((l) => (
            <div key={l.name} className="lang" data-reveal>
              <span className="lang__hello">{l.hello}</span>
              <span className="lang__name">
                {l.native}
                {l.native !== l.name && <i> · {l.name}</i>}
              </span>
            </div>
          ))}
          <a href="#demo" className="lang lang--more" data-reveal>
            <span className="lang__hello">+ many more</span>
            <span className="lang__name">Don't see yours? Ask on your demo call.</span>
          </a>
        </div>
      </div>
    </section>
  );
}
